

























import { Component, Vue } from 'vue-property-decorator';
import { GetAllFromTable } from '@/services/airtable.service';
import { getModule } from 'vuex-module-decorators';
import { MapStore } from '@/store/map';

@Component
export default class WidgetRecruitmentPool extends Vue {
  records: JobStatistic = [];
  colors: Array<any> = ['rgb(255,39,231)', 'rgb(132,60,12)', 'rgb(77,214,76)', 'rgb(255,100,4)', 'rgb(35,87,255)'];
  city: string = getModule(MapStore, this.$store).city;
  created() {
    this.$root.$on('city', (e: string) => {
      this.city = e;
      this.update();
    });
    this.update();
  }
  update() {
    GetAllFromTable<JobStatistic>('appjz0KI3EQeBlaT1', 'Emploi')
      .then(response => {
        const records: JobStatistic = {};
        if (this.city) {
          const record = response.find(record => record.fields.Ville === this.city);
          if (record) {
            Object.keys(response[0].fields).forEach(field => (records[field] = 0));
            Object.keys(record.fields).forEach(field => {
              records[field] = record.fields[field];
            });
          }
          delete records['lat'];
          delete records['lng'];
          this.records = records;
        } else {
          Object.keys(response[0].fields).forEach(field => (records[field] = 0));
          response.forEach((record: JobStatistic) => {
            Object.keys(record.fields).forEach(field => {
              records[field] = records[field] + record.fields[field];
            });
          });
          delete records['lat'];
          delete records['lng'];
          this.records = records;
        }
      })
      .catch(error => {
        console.log(error);
      });
  }
}

interface JobStatistic {
  [key: string]: any;
  name?: string;
  value?: number;
  Ville?: string;
  lat?: string;
  lng?: string;
}
